import React from 'react';
import Form from './Form/Form';
import I18n from './I18n';
import 'rctui/styles/reset.scss';

const AuthForm = React.createClass({

  getInitialState: function () {
    return {
      disabled: false,
      values: {},
      errors: [],
      company: ''
    };
  },

  componentDidMount: function () {
    localStorage.removeItem('currentComponent');
    this.state.company = document.body.dataset.company;
  },

  handleSubmit: function (e) {
    this.setState({
      disabled: true
    });

    let self = this;
    this.state.values.company = (this.state.values.company!="")?  this.state.values.company : this.state.company;
    $.post('/login', this.state.values, function (r) {
      if (r.errors) {
        self.setState({
          errors: r.errors
        });
      } else {
        location.href = r.url;
      }
      self.setState({
        disabled: false
      });
    });
    return false;
  },

  render: function () {
    return (
      <div className="authContainer authContainerDc">
        <h1 className="authTitle"><I18n message="authorization.title"/>
          {/* <img src={'/img/dc/' + document.body.dataset.company + '_logo.png'} className="authLogo"/> */}
          <img src={'/img/dc/matrix_logo.svg'} className="authLogo admin_login_logo"/>
        </h1>
        <div className="authInnerBox">
          <Form onSubmit={this.handleSubmit}
                errors={this.state.errors}
                submitText="button.enter"
                disabled={this.state.disabled}
                items={this.formItems}
                values={this.state.values}
          />
        </div>
      </div>
    );
  },

  formItems: [
    {
      label: "user.field.Login",
      name: "login",
      type: "numeric",
      value: ''
    },
    {
      label: "user.field.Password",
      name: "password",
      type: "password",
      value: ""
    },
    {
      name: "company",
      type: "hidden",
      value: document.body.dataset.company
    }
  ]
});

export default AuthForm;



// WEBPACK FOOTER //
// ./src/js/Component/AuthForm.jsx